var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.237 0.157719L0.609738 13.2117C-0.273873 13.7194 -0.161591 14.9497 0.717138 15.3207L5.90653 17.498L19.932 5.13719C20.2005 4.89798 20.5813 5.26412 20.3519 5.54238L8.59153 19.8706V23.8004C8.59153 24.9525 9.98285 25.4066 10.6663 24.5718L13.7663 20.7981L19.849 23.3464C20.5423 23.6393 21.3331 23.2048 21.46 22.4579L24.975 1.36841C25.1409 0.382283 24.0816 -0.330464 23.237 0.157719Z",
    fill: "#202E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.22b46b03efa3612afb4fb9dc3758151b.svg";
export { ForwardRef as ReactComponent };